import { Badge, Box, Flex, IconButton, Text } from '@chakra-ui/react'
import { Icon } from 'components/atoms'
import { useAuthContext } from 'contexts/auth'
import { memo } from 'react'
import formatter from 'utils/formatter'

interface Notification {
    guid: string
    titulo: string
    descricao: string
    dataCriacao: string
    lida: boolean
}

interface NotificationItemProps {
    notification: Notification
    onSelect: (notification: Notification) => void
    onRemove: (guid: string) => void
}

const NotificationItemFC = ({
    notification,
    onSelect,
    onRemove
}: NotificationItemProps) => {
    const handleRemove = (e: React.MouseEvent) => {
        e.stopPropagation()
        onRemove(notification.guid)
    }

    const { isBackoffice } = useAuthContext()
    const isMasterIF = !isBackoffice

    return (
        <Box
            key={notification.guid}
            p={4}
            borderBottomWidth="1px"
            cursor="pointer"
            onClick={() => onSelect(notification)}
            bg={notification.lida || isBackoffice ? 'white' : 'blue.50'}
            _hover={{ bg: 'gray.50' }}
            transition="background-color 0.2s"
            position="relative"
        >
            <Flex justify="space-between" align="flex-start" gap={4}>
                <Box flex="1">
                    <Flex align="center" gap={2} mb={1}>
                        <Text
                            fontSize="sm"
                            fontWeight={
                                notification.lida ? 'normal' : 'semibold'
                            }
                            noOfLines={1}
                        >
                            {notification?.titulo}
                        </Text>
                        {!isBackoffice && !notification?.lida && (
                            <Badge
                                colorScheme="blue"
                                variant="solid"
                                fontSize="xs"
                            >
                                Nova
                            </Badge>
                        )}
                    </Flex>
                    <Text fontSize="sm" color="gray.600" noOfLines={2}>
                        {notification?.descricao}
                    </Text>
                </Box>

                <Flex direction="column" align="flex-end" gap={2}>
                    <Text fontSize="xs" color="gray.500" whiteSpace="nowrap">
                        {formatter.dataWithHour(notification?.dataCriacao)}
                    </Text>
                    {((isMasterIF && notification.lida) || isBackoffice) && (
                        <IconButton
                            aria-label="Apagar notificação"
                            icon={<Icon name="delet" />}
                            size="sm"
                            variant="ghost"
                            colorScheme="red"
                            onClick={handleRemove}
                            _hover={{ bg: 'red.50' }}
                        />
                    )}
                </Flex>
            </Flex>
        </Box>
    )
}

export const NotificationItem = memo(NotificationItemFC)
